import storage from 'redux-persist/lib/storage'

export const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'config', 'licenseError'],
  blacklist: ['UI', 'DashboardConfig', 'annotation', 'renewedPipeline', 'labeling'],
}
